import { Heading } from "@chakra-ui/react"

function Docs() {
  return (
    <>
        <Heading>Docs</Heading>
    </>
  )
}
export default Docs